import React, { Component } from "react";
import DisplayTheme from "../../../../../Layouts/Main/Themes";

class OnboardingPreview extends Component {
    render() {
        const { wallId, wallData, hasPosts } = this.props;
        // real posts exist for this wall - never show the demo-post strip, even while the stale wall data (demoWall on, no-posts error) is still being refreshed
        return <DisplayTheme showDemoWall={hasPosts ? 0 : wallData?.wall?.Personalization?.demoWall} errorCode={wallData?.error_code} error={wallData?.error} params={{ wallID: wallId }} />
    }
}

export default OnboardingPreview;
